import React from 'react';
import { AttrTrackingProvider } from '@unisporkal/attr-tracking/react';
import { useExperience } from '@unisporkal/experiences';
import { getAttrTrackingMap } from '../../../src/react/config/tracking';

/**
 * Mounts the `data-trk-mfeid` scope and registers the map for one React root.
 *
 * A component rather than a hook call in `Providers`, because `useExperience`
 * needs `ExperiencesProvider` above it and that is mounted inside `Providers`.
 */
const AttrTracking = ({ children }: { children: React.ReactNode }) => {
  const isDecouplingActive = useExperience('GA4DecouplingLanding').isActive();

  return (
    <AttrTrackingProvider map={getAttrTrackingMap(isDecouplingActive)}>
      {children}
    </AttrTrackingProvider>
  );
};

export default AttrTracking;
